export const DDIA_INITIATE_PROPOSAL_FORM_ID = 'ddia-initiate-proposal-form';
